/**
 * Where a widget reads and where it submits (SMA-86).
 *
 * Reads and report intake both go to the public API on the api subdomain (SMA-86, SMA-88).
 * The loaders inject both bases (`_baseUrl` for widgets, `_apiUrl` for the API); a loader cached
 * before `_apiUrl` existed still works because the api base derives from the widgets base.
 * A hosted page inlines its document (SMA-76) and supplies the api base for the intake itself.
 */

export function apiBaseFrom(widgetsBase: string, apiBase?: string | null): string {
  if (apiBase) return apiBase.replace(/\/$/, '');
  return widgetsBase.replace(/\/$/, '').replace('widgets.', 'api.');
}

export type PublicResource = 'policies' | 'briefs' | 'portals';

export function publicResourceUrl(apiBase: string, resource: PublicResource, id: string): string {
  return `${apiBase.replace(/\/$/, '')}/v1/p/${resource}/${id}`;
}

/** Report intake on the public API (SMA-88): a nested create on the brief. */
export function reportIntakeUrl(apiBase: string, shortcode: string): string {
  return `${apiBase.replace(/\/$/, '')}/v1/p/briefs/${shortcode}/reports`;
}
